export default class Email {
    static valid(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
}